import { Link } from "react-router-dom";

import Footer from "../../components/marketing/engineering/Footer";
import Seo from "../../components/seo/Seo";
import MarketingLayout from "../../layouts/MarketingLayout";
import Eyebrow from "../../components/marketing/Eyebrow";

/**
 * Fallback route for unknown URLs.
 * Translation: Fallback route for unknown URLs.
 *
 * @returns {JSX.Element} 404 route.
 */
const Page404 = () => (
  <>
    <Seo
      title="Page Not Found | Data Chimp Labs"
      description="The page you are looking for could not be found."
      pathname="/404"
    />

    <MarketingLayout footer={<Footer />} showFloatingBadge={false}>
      <section className="page-not-found">
        <div className="section-shell page-not-found__inner">
          <Eyebrow>404</Eyebrow>
          <h1>Page Not Found</h1>
          <p className="section-intro">
            The page you are looking for is not available.
          </p>
          <Link to="/" className="button button-primary">
            Return Home
          </Link>
        </div>
      </section>
    </MarketingLayout>
  </>
);

export default Page404;
